import React, { useRef } from 'react';

export default function InputText(props) {
  const {
    className,
    inputType,
    inputClassName,
    placeholder,
    name,
    value,
    setValue,
    setDirty,
    labelText,
    disableAutoComplete,
    min
  } = props;
  const inputRef = useRef();

  return (
  <div className={`input-text df fxdrc w330 w100%@sm ${ className || ''}`}>
    {labelText && 
    <label
      className="input-text__label fw600 c-black mb8 lh1.5"
      htmlFor={name}
    >
      {labelText}
    </label>
    }
    <input
      className={`input-text__input h54 p16 ff-gr fw500 bdrs8 bd2-s-gray-light ${ inputClassName || '' }`}
      ref={inputRef}
      type={inputType || 'text'}
      id={name}
      name={name}
      value={value}
      autoComplete={disableAutoComplete ? 'off' : 'on'}
      onChange={e => setValue({ [name] : inputRef.current.value })}
      onBlur={e => setDirty({ [`${name}Dirty`] : true })}
      placeholder={placeholder}
      min={min}
    />
  </div>
  )
}
